module.exports = __webpack_public_path__ + "img/watch_icon.6640922f.svg";